import WalkerSitterAPI from '@/app/apis/main/walker-sitter/walker-sitter-api.js';

export default {
	async putWalkerSitterDetails(walkerSitterDetails) {
		return WalkerSitterAPI.putWalkerSitterDetails(walkerSitterDetails);
	},

	/**
	 * @returns {object} walker sitter list
	 */
	async getWalkerSitterList(walkerSitterDetails) {
		return WalkerSitterAPI.getWalkerSitterList(walkerSitterDetails);
	},

	/**
	 * @param {*} availabilityDetails
	 */
	async postWalkerSitterAvailability(availabilityDetails) {
		return WalkerSitterAPI.postWalkerSitterAvailability(availabilityDetails);
	},

	saveToFavorite(bodyParams) {
		return WalkerSitterAPI.saveToFavorite(bodyParams);
	}
}